import { render, staticRenderFns } from "./sheBeiLogin.vue?vue&type=template&id=99b2ca78&scoped=true&"
import script from "./sheBeiLogin.vue?vue&type=script&lang=js&"
export * from "./sheBeiLogin.vue?vue&type=script&lang=js&"
import style0 from "./sheBeiLogin.vue?vue&type=style&index=0&id=99b2ca78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b2ca78",
  null
  
)

export default component.exports